import { Fragment } from 'react';
import { TermContentText, TermContentTextBold } from '../../TermsModal/styles';

export const FullSearchFeeTerm = () => {
  return (
    <Fragment>
      <TermContentText>
        1. Within one (1) week of signing this Agreement, the Client shall pay
        the Company a
        <TermContentTextBold>
          &nbsp;non-refundable fee of S$50.00
        </TermContentTextBold>
        &nbsp;in consideration for work done by the Company to conduct
        pre-screening processes for a Sitter (“Search Fee”). In consideration
        for providing the Service, the Client shall pay to the Company the
        Search Fee as set out in this Agreement. In the event that there is no
        sitter profile surfaced, the Search Fee will be refunded to the Client
      </TermContentText>
      <TermContentText>
        2. If there are changes to bookings, any remaining credits for unused
        services will be rolled over for subsequent bookings. The Service Fees
        and the Sitters Fees are strictly non-refundable.
      </TermContentText>
    </Fragment>
  );
};

export default FullSearchFeeTerm;
